import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';

@Injectable()
export class ClubComplexService {

  private _api = '/api/club';
  private _apiTeam = '/api/team';
  private _apiClubProgram = '/api/clubProgram';
  private _apiPlayer = '/api/player';

  links: { title: string; url: any; }[];

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  //Dashboard
  getClubComplexListWithCounts(clubID: number) {
    return this.httpService.get(`${this._api}/get-club-complex-list-with-counts/${clubID}`);
  }
  deleteComplexeForClub(complexID: number, clubID: number) {
    return this.httpService.delete(`${this._api}/delete-complexe-for-club/${complexID}/${clubID}`);
  }

  //END My Teams Page

  // Add Club Complex
  getClubComplexInfo(complexID: number) {
    return this.httpService.get(`${this._api}/get-club-complex-info/${complexID}`);
  }
  addNewComplexForClub(complexDataObj: any) {
    return this.http.post(this._api + '/add-new-complex-for-club', complexDataObj);
  }
  updateComplexForClub(complexDataObj: any, clubID: number) {
    return this.http.post(this._api + `/update-complex-for-club/${clubID}`, complexDataObj);
  }
  // END Add Club Complex

  // Add Club Complex Venues
  getTypeOfVenues() {
    return this.httpService.get(`${this._api}/get-venue-type`);
  }
  getClubComplexVenues(clubID: number, complexID: number) {
    return this.httpService.get(`${this._api}/get-club-complex-venues/${clubID}/${complexID}`);
  }
  deleteVenuesForClubComplex(venueID: number) {
    return this.httpService.delete(`${this._api}/delete-venues-for-club-complex/${venueID}`);
  }
  saveVenuesForClubComplex(venuesDataList: any[]) {
    return this.http.post(this._api + '/save-venues-for-club-complex', venuesDataList);
  }
  getVenueNoteByVenue(venueID: number) {
    return this.httpService.get(`${this._api}/get-venue-note-by-venue/${venueID}`);
  }
  saveOrUpdateVenueNote(venueNoteData: any) {
    return this.http.post(this._api + '/save-or-update-venue-note', venueNoteData);
  }
  //END Add Club Complex Venues

  // Complex Venue Availability
  getVenueAvailability(venueID: number, clubID: number, complexID: number, flag: number) {
    return this.httpService.get(`${this._api}/get-venue-availability/${venueID}/${clubID}/${complexID}/${flag}`);
  }
  addVenueAvailability(venueData: any) {
    return this.http.post(this._api + '/add-venue-availability', venueData);
  }
  updateVenueAvailability(venueData: any) {
    return this.http.post(this._api + '/update-venue-availability', venueData);
  }
  deleteVenueAvailability(venueID: number, venueAvailabilityID: number, venueStartDate: any) {
    return this.http.delete(this._api + `/delete-venue-availability/${venueID}/${venueAvailabilityID}/${venueStartDate}`);
  }
  // END Complex Venue Availability
}



// WEBPACK FOOTER //
// ./src/app/services/club-complex.service.ts